import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const InvoiceUpdateModalUI = ({context, messageList, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // invoice name
    invoiceName, onInvoiceNameChange, invoiceNameError, setInvoiceNameError,
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_update_invoice'
    buttonMessageKey='c_update'
    cancelMessageKey='c_cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='invoiceName' required={true} maxLength={100}
      messageList={messageList} labelKey='c_invoice_name'
      value={invoiceName} onChange={onInvoiceNameChange}
      error={invoiceNameError} setError={setInvoiceNameError}
      autoFocus={true}
    />
  </ModalFormUI>

export default InvoiceUpdateModalUI
